import React, { useEffect, useState } from "react";
import "./Blog.css";
import Blog_card from "./blog_card/Blog_card";
import Breadcrumb_comp from "../common_components/breadcrumb-comp/Breadcrumb_comp";
import { useDispatch, useSelector } from "react-redux";
import { getblog } from "../../features/blog/Slice";
function Blog() {
  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "BLOG", link: "", isActive: true },
  ];

  const blogData = [
    {
      baseLink: "/blog-inner",
      imgSrc: "/assets/images/blog/img1.png",
      headingText: "Is Store-Bought Honey Fake?",
      discText:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    },
    {
      baseLink: "/blog-inner",
      imgSrc: "/assets/images/blog/img2.png",
      headingText: "5 Smart Ways to Use Groundnut Oil",
      discText:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    },
    {
      baseLink: "/blog-inner",
      imgSrc: "/assets/images/blog/img1.png",
      headingText: "Is Ghee Actually Healthy?",
      discText:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    },
    {
      baseLink: "/blog-inner",
      imgSrc: "/assets/images/blog/img1.png",
      headingText: "The Truth About Organic Dal",
      discText:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    },
    {
      baseLink: "/blog-inner",
      imgSrc: "/assets/images/blog/img1.png",
      headingText: "The Secret to Perfect Biryani Rice",
      discText: "Learn which rice variety works best and how to cook it right.",
    },
    {
      baseLink: "/blog-inner",
      imgSrc: "/assets/images/blog/img1.png",
      headingText: "Is Store-Bought Honey Fake?",
      discText:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    },
    {
      baseLink: "/blog-inner",
      imgSrc: "/assets/images/blog/img2.png",
      headingText: "5 Smart Ways to Use Groundnut Oil",
      discText:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    },
    {
      baseLink: "/blog-inner",
      imgSrc: "/assets/images/blog/img1.png",
      headingText: "Is Ghee Actually Healthy?",
      discText:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    },
    {
      baseLink: "/blog-inner",
      imgSrc: "/assets/images/blog/img1.png",
      headingText: "The Truth About Organic Dal",
      discText:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    },
    {
      baseLink: "/blog-inner",
      imgSrc: "/assets/images/blog/img1.png",
      headingText: "Is Ghee Actually Healthy?",
      discText:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    },
    {
      baseLink: "/blog-inner",
      imgSrc: "/assets/images/blog/img1.png",
      headingText: "The Truth About Organic Dal",
      discText:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    },
  ];

  const blog = useSelector((state) => state.blog.blog);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getblog());
  }, [dispatch]);

  const itemsPerPage = 8;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(blog?.data?.length / itemsPerPage);

  const handlePageChange = (pageNum) => {
    if (pageNum >= 1 && pageNum <= totalPages) {
      setCurrentPage(pageNum);
    }
  };

  const paginatedData = blog?.data?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <section className="Blog">
      <Breadcrumb_comp breadcrumbs={breadcrumbs} />
      <div className="container">
        <div className="blog_card_holder">
          <div className="row">
            {paginatedData &&
              paginatedData.map((blog, index) => (
                <div
                  className="col-xxl-3 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6"
                  key={index}
                >
                  <Blog_card
                    baseLink={`/blog-inner/${blog.id}`}
                    blogData={blog}
                  />
                </div>
              ))}
          </div>

          {/* Pagination UI */}
          <div className="pagination mt-4 d-flex justify-content-center align-items-center gap-2">
            <button
              onClick={() => handlePageChange(1)}
              disabled={currentPage === 1}
            >
              &laquo;
            </button>
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              &lsaquo;
            </button>

            {/* Always show first two pages */}
            {[currentPage].map((page) => (
              <button
                key={page}
                onClick={() => handlePageChange(page)}
                className={page === currentPage ? "active" : ""}
              >
                {page}
              </button>
            ))}
            {/* Show ... if there are more than 3 pages */}
            {totalPages > 3 && (
              <>
                <span>...</span>

                {/* Show last page */}
                <button
                  onClick={() => handlePageChange(totalPages)}
                  className={currentPage === totalPages ? "active" : ""}
                >
                  {totalPages}
                </button>
              </>
            )}

            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              &rsaquo;
            </button>
            <button
              onClick={() => handlePageChange(totalPages)}
              disabled={currentPage === totalPages}
            >
              &raquo;
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Blog;
